/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import CopyToClipboard from "react-copy-to-clipboard";
import { Box, FlexContainer, SVGIcon, theme } from "@nordcloud/gnui";
import { showSimpleInfo } from "~/services/toast";

type Props = {
  children: string;
};

export function CopyBox({ children }: Props) {
  return (
    <Box
      boxStyle="grey"
      marginBottom={theme.spacing.spacing01}
      padding={theme.spacing.spacing02}
    >
      <FlexContainer justifyContent="space-between">
        {children}
        <CopyToClipboard
          text={children}
          css={{
            cursor: "pointer",
          }}
          onCopy={() => showSimpleInfo("Command copied to clipboard")}
        >
          <SVGIcon name="copy" />
        </CopyToClipboard>
      </FlexContainer>
    </Box>
  );
}
